import { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import TokenService from '../Services/Token.service'; // Adjust path if needed

const AuthMiddleware = ({ children }) => {
    const navigate = useNavigate();

    // useEffect(() => {
    //     const user = TokenService.getUser();
    //     if (user) {
    //         const role = user.roles[0]?.toLowerCase();
    //         if (role === 'superadmin') {
    //             navigate('/admin/dashboard');
    //         } else {
    //             navigate(`/${role}/dashboard`);
    //         }
    //     }
    // }, [navigate]);
    useEffect(() => {
        const user = TokenService.getUser();
        if (user) {
            const superAdminRole = user.roles.find((role) => role.toLowerCase() === 'superadmin');
            if (superAdminRole) {
                navigate('/admin/dashboard');
            } else {
                const defaultRole = user.roles[0]?.toLowerCase(); // Use the first role as the default
                navigate(`/${defaultRole}/dashboard`);
            }
        }
    }, [navigate]);
    
    // If no user is logged in, render the component passed to ProtectedRoute
    return !TokenService.getUser() ? children : <Outlet />;
};

export default AuthMiddleware;